import {sortBy} from 'lodash'
import clsx from 'clsx'
import React, {useContext} from 'react'
import Fade from '@mui/material/Fade'
import Box from '@mui/material/Box'
import LinesEllipsis from 'react-lines-ellipsis'
import {makeStyles} from 'external/material'

import {TeacherContext} from 'teacher/context'

import matchingHandler from '../preview-questions/matching/index'
import fillInTheBlanksHandler from '../preview-questions/fill-in-the-blanks/index'
import multipleChoiceHandler from '../preview-questions/multiple-choice/index'
import openQuestionHandler from '../preview-questions/open-question/index'
import trueOrFalseHandler from '../preview-questions/true-or-false/index'

const questionHandlers = {
  'matching': matchingHandler,
  'fill-in-the-blanks': fillInTheBlanksHandler,
  'multiple-choice': multipleChoiceHandler,
  'open-question': openQuestionHandler,
  'true-or-false': trueOrFalseHandler
}

const useStandardStyles = makeStyles(standardStyles)

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 4,
    backgroundColor: '#fff',
    flexGrow: 1,
    color: '#4e566d',
    fontSize: '12pt',
    "& > .header": {
      padding: '10px 15px',
      borderBottom: 'solid 1px #dfdfdf',
      borderTopLeftRadius: 4,
      borderTopRightRadius: 4,
      backgroundColor: '#1d9be5',
      color: '#fff',
    },
    "& > .content": {
      flexGrow: 1
    },
    "& > .points" : {
      padding: "20px 15px",
      display: "flex",
      "& > div" : {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center"
      },
      "& .points-label": {
        marginRight: 4
      },
      "& .points-value": {
        marginTop: 2
      }
    }
  },
}))

export default function PreviewQuestion ({context, question, headless, showPoints}) {

  const classes = useStyles()
  const {translate, quizQuestionTypes} = context

  const {id, properties = {}, type} = question

  const loaded = id != undefined
  const questionType = quizQuestionTypes.find(t => t.id == type) || {}
  const Handler = questionHandlers[questionType.name]

  const titleLabel = (properties.title || '') == '' ? translate(questionType.name) : properties.title

  return (
    // <Fade in={loaded}>
      <Box className={clsx(classes.root, "section")}>
        {!headless && <Box className="header">
          {titleLabel}
        </Box>}
        <Box className="content">
            {Handler && <Handler
              question={question}
              context={context}
            />}
        </Box>
        {showPoints && <Box className="points">
          <Box className="points-label">{translate('points')}:</Box>
          <Box className="points-value">{question.value}</Box>
        </Box>}
      </Box>
    // </Fade>
  )
}

function Standards ({question}) {

  const classes = useStandardStyles()
  const context = useContext(TeacherContext)

  const {translate} = context
  const {standards = []} = question.properties || {}

  const sortedStandards = sortBy(standards, s => {
    const iteratee = `${s.expectation || s.id}-${s.code || '00'}`
    return iteratee
  })

  return (<>
    <Box className={classes.standardsLabel}>{translate('standards')}:</Box>
    <Box className={classes.standards}>
      {sortedStandards.map((standard, index) => <Standard index={index} key={index} {...standard} />)}
    </Box>
  </>)
}

function Standard (props) {
  const classes = useStandardStyles()
  const context = useContext(TeacherContext)
  const {translate} = context
  const {id, code, description} = props
  return (
    <div className={classes.standard}>
      <div className={clsx(classes.item, classes.content)}>
        <div className={classes.code}>{code == undefined ? translate("expectation") : code}</div>
        <div className={classes.description} title={description}>
          <LinesEllipsis
            text={description}
            maxLine={3}
            ellipsis="..."
            trimRight
            basedOn='letters'
          />
        </div>
      </div>
    </div>
  )
}


function standardStyles(theme) {
  return {
    standardsLabel: {
      paddingLeft: 15,
    },
    standard: {
      flexGrow: 1,
      display: 'flex',
      justifyContent: 'flex-start',
      borderBottom: 'solid 1px #e2ecf2',
      "&:last-child": {
        borderBottom: 'none'
      }
    },
    item: {
      display: 'flex',
      flexDirection: 'column'
    },
    content: {
      cursor: 'default',
      flexGrow: 1,
      color: '#4e576e',
      overflowX: 'hidden',
      padding: '8px 10px 20px 20px',
    },
    code: {
      textTransform: 'uppercase',
      fontWeight: 'bold'
    },
    description: {
      color: '#838999',
      fontSize: '10.5pt',
      wordWrap: 'break-word'
    },
    actions: {
      justifyContent: 'center',
      paddingRight: 10
    },
  }
}
